.tableFooter {
  display: block;

  .tr {
    display: flex;
    width: fit-content;
    min-width: 100%;

    &:not(:last-child) {
      border-bottom: 1px solid var(--ixf-table-border);
    }

    .pendingData {
      width: 100%;
    }
  }

  .aggregateRow {
    display: flex;
    border-top: 1px solid var(--ixf-text-tone-md);
  }
}
